import React, {useState} from 'react'
import Interface from '../../components/Interface'
import text from '../../constants/Cromatica'
import { uri } from '../../services/defaultProps'
import WhatsAppIcon from '../../assets/images/whatsapp-icon.png'
import Loader from 'react-loader-spinner'
import rp from 'request-promise-native'
import sendMessageWPP from '../../services/sendMessageWPP'

const requestService = (language, token, setLoadingReqService) => {
  const reqServiceMessage = (consultant) => ([
    `Olá ${consultant}. Vi no MOSTY que posso descobrir as cores que mais me valorizam com você. Pode me explicar como funciona?`,
    `Hello ${consultant}. I saw on MOSTY that I can find the colors that most value me with you. Can you explain how it works?`,
    `Hola, ${consultant}. Vi en MOSTY que puedo descubrir los colores que más me valoran contigo. ¿Puedes explicar cómo funciona?`
  ])

  rp({
    uri: `${uri}/user`,
    method: 'GET',
    headers: {
      Authorization: token
    },
    json: true
  }).then(({consultantName, consultantPhone}) => {
    sendMessageWPP(
      consultantPhone,
      reqServiceMessage(consultantName)[language]
    )
  }).catch((err) => {
    console.log(err)
  }).finally(() => {
    setLoadingReqService(false)
  })

  setLoadingReqService(true)
}

const MissingColor = ({ language, history, token }) => {
  const [loadingReqService, setLoadingReqService] = useState(false)

  return (
    <Interface logoImg='assets/coloracao.png' title={['coloração pessoal', 'personal coloring', 'coloración personal'][language]} history={history}>
      <div id='listaText'>
        {
          !loadingReqService
            ? <div className='request-service'>
              {text.notConfig[language]}<br /><br />
              <span className='link' onClick={() => requestService(language, token, setLoadingReqService)}>
                {text.notConfSendLink[language]}&nbsp;
              </span>
              <span>{text.notConfSendMessage[language]}</span>
              <img src={WhatsAppIcon} alt='WhatsApp' />
            </div>
            : <div style={{ position: 'absolute', top: 100, left: '50%', transform: 'translate(-50%, 0)' }}>
              <Loader
                type='TailSpin'
                color='#6d357b'
                height='50'
                width='50'
              />
            </div>
        }
      </div>
    </Interface>
  )
}

export default MissingColor



// WEBPACK FOOTER //
// ./src/containers/Cromatica/MissingColor.js